'use client';

import { c as _c } from "react/compiler-runtime";
import useIsDarkModeStore from '@module/stores/useIsDarkModeStore';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import { useEffect, useState } from 'react';
export default function DarkModeButton() {
  const $ = _c(11);
  const {
    isDark,
    darkModeChange
  } = useIsDarkModeStore();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== darkModeChange || $[3] !== isDark) {
    t2 = () => {
      darkModeChange(!isDark);
    };
    $[2] = darkModeChange;
    $[3] = isDark;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleTheme = t2;
  const t3 = mounted ? isDark ? "\uB77C\uC774\uD2B8\uBAA8\uB4DC" : "\uB2E4\uD06C\uBAA8\uB4DC" : "\uB2E4\uD06C\uBAA8\uB4DC";
  let t4;
  if ($[5] !== t3) {
    t4 = {
      content: t3
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div id="isDarkButton" className="h-[36px] w-[36px] bg-50% bg-icon-is-dark bg-size-24 bg-no-repeat" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== toggleTheme) {
    t6 = <BaseButton tooltip={t4} variant="ghost" size="none" className="flex h-[48px] w-[48px] items-center justify-center rounded-full hover:bg-menuHover focus:outline-none" onClick={toggleTheme}>{t5}</BaseButton>;
    $[8] = t4;
    $[9] = toggleTheme;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}